import React from 'react';

export const TransformComparisonDropdown = ({
  options,
  onSelect,
  value,
}: {
  options: string[];
  onSelect: (value: string) => void;
  value: string | null;
}) => {
  return (
    <div>
      <label
        htmlFor="transform-comparison-dropdown"
        style={{
          display: 'inline-block',
          marginBottom: '8px',
          marginRight: '4px',
        }}
      >
        Transform To Compare:
      </label>
      <select
        className="form-select"
        id="transform-comparison-dropdown"
        onChange={(e) => onSelect(e.target.value)}
        value={value ?? ''}
      >
        <option value="" disabled>
          -- Please select --
        </option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};
